<template>
  <div class="vb-pratica">
    <div class="vb-pratica__panel">
      <component :is="title_tag" class="vb-heading h2">I dettagli della tua prenotazione</component>
      <p class="vb-pratica__intro">
        <slot name="details-subtitle">
          <template v-if="has_flights">Verifica con attenzione i dettagli del pacchetto che stai prenotando.</template>
          <template v-else>Verifica con attenzione i dettagli del soggiorno che stai prenotando.</template>
        </slot>
      </p>
      <services
        :services="services"
        :boxed="true"
        :statics_fallback="statics_fallback"
      />
      <services-insurance
        class="vb-pratica__insurance"
        :flat="true"
        :flight_and_stay="has_flights"
      />
    </div>

    <div class="vb-pratica__panel">
      <h2 class="vb-heading h5">I dati dei viaggiatori</h2>
      <p class="vb-pratica__subtitle mb-0">
        Verifica con attenzione i dati personali dei partecipanti al viaggio che
        devono corrispondere a quelli presenti sui documenti che utilizzerai per
        <span v-if="has_flights">i checkin aeroportuali e alberghieri.</span>
        <span v-else> il check-in alberghiero. </span>
      </p>
      <b-row>
        <card-pax
          v-for="(paxs, paxs_index) in passengers"
          :key="`${_uid}:${paxs_index}`"
          :pax="paxs"
          :index="paxs_index + 1"
          :col="'col-xl-6'"
        />
      </b-row>
    </div>
  </div>
</template>

<script>
import { has_flights } from "@alpitour/utilities";
import Services from "@alpitour/components/blocks/services.vue";
import CardPax from "@alpitour/components/blocks/card-pax.vue";
import ServicesInsurance from "@alpitour/components/blocks/detail/assicurazione-medico-bagaglio.vue";
export default {
  name: "pratica",
  props: {
    services: Object,
    passengers: Array,
    statics_fallback: {
      type: Boolean,
      default: true,
    },
    title_tag: {
      type: String,
      default: "h1",
      validator: (value) => ["h1", "h2", "h3"].includes(value),
    },
  },
  components: {
    services: Services,
    "card-pax": CardPax,
    "services-insurance": ServicesInsurance,
  },
  computed: {
    has_flights() {
      return has_flights(this.services);
    },
  },
};
</script>

<style lang="scss">
.vb-pratica {
  &__panel {
    @extend %section__content;
    margin-top: 0;
    margin-bottom: $grid-gutter-width;
    line-height: $line-height-base;
  }

  &__intro {
    margin-bottom: $grid-gutter-width;
  }

  &__subtitle {
    font-size: $font-size-md;
  }

  & &__insurance {
    margin-top: $grid-gutter-width;

    .services-insurance {
      .vb-heading {
        font-size: $h5-font-size;
        margin-bottom: $headings-margin-bottom;
      }
    }
  }
}
</style>
